export const getColWidth = (cols, totalCols = 12) => {
  const width = (cols / totalCols) * 100
  const total = `${width}%`

  return total
}
